import React from 'react';
import ReactDOM from 'react-dom';
import { Footer} from 'rsuite';

class CUSTFooter extends React.Component {
     render() {
         return <Footer className="footer_custom mt-2">
      <hr className="line1"></hr>

          <p className="grey-text text-center">© 2022, Neiman Marcus | <a style={{ textDecoration: 'none',color:"black" }}  href="https://www.neimanmarcus.com/en-in/assistance/assistance.jsp?itemId=catCNAssistance">Terms & Conditions and Privacy Policy</a></p>
      </Footer>   
  }
    
   
}

export default CUSTFooter;